import type { TranslationKey } from '@/i18n';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const ACADEMIA_ID_PATTERN = /^ZA\d{6}$/i;
export const PASSWORD_SPECIALS = '!@#$%&*?_-';

export const validateEmail = (email: string): TranslationKey | undefined =>
  EMAIL_PATTERN.test(email.trim()) ? undefined : 'auth.error.email';

export const validateLoginIdentifier = (value: string): TranslationKey | undefined => {
  const trimmed = value.trim();
  if (!trimmed) return 'auth.error.email';
  if (EMAIL_PATTERN.test(trimmed) || ACADEMIA_ID_PATTERN.test(trimmed)) return undefined;
  return 'auth.error.email';
};

export interface PasswordChecklist {
  length: boolean;
  upper: boolean;
  lower: boolean;
  digit: boolean;
  special: boolean;
  match: boolean;
}

export const passwordChecklist = (password: string, confirm = password): PasswordChecklist => ({
  length: [...password].length >= 6 && [...password].length <= 128,
  upper: /[A-Z]/.test(password),
  lower: /[a-z]/.test(password),
  digit: /\d/.test(password),
  special: [...password].some((char) => PASSWORD_SPECIALS.includes(char)),
  match: password.length > 0 && password === confirm,
});

export const validatePassword = (password: string): TranslationKey | undefined =>
  Object.values(passwordChecklist(password)).every(Boolean) ? undefined : 'auth.error.password';

export interface LoginErrors {
  email?: TranslationKey;
  password?: TranslationKey;
}

export interface RegisterErrors extends LoginErrors {
  confirmed?: TranslationKey;
}

export const validateLogin = (email: string, password: string): LoginErrors => {
  const errors: LoginErrors = {};
  const emailError = validateLoginIdentifier(email);
  const passwordError = password.trim() ? undefined : 'auth.error.passwordRequired';
  if (emailError) errors.email = emailError;
  if (passwordError) errors.password = passwordError;
  return errors;
};

export const validateRegister = (
  email: string,
  password: string,
  confirmed: boolean,
): RegisterErrors => {
  const errors: RegisterErrors = validateLogin(email, password);
  if (!confirmed) errors.confirmed = 'auth.error.confirm';
  return errors;
};
